import { ISession } from '../types';

export function assertSession(session: ISession | undefined) {
  if (!session) {
    throw new Error(
      '[MlSearchSession] mlSearchSession must be initialized before accessing it. Forgot to call init() before accessing mlSearchSession?',
    );
  }
}
